import Vue from "vue";
import $ from "jquery";
import axios from "axios";
import Editor from "@tinymce/tinymce-vue";
import { siteURL, apiURL, assetsURL } from "@/utils";

Vue.component("search-zipcode-sec", {
  template:
    '\
        <span> \
            <el-dialog title="우편번호 검색" :visible.sync="isSearchPostsView" :width="isMobile() ? \'100%\' : \'60%\'"> \
              <div class="pop-body"> \
                <div class="search-type sm"> \
                  <table> \
                    <colgroup> \
                      <col /> \
                    </colgroup> \
                    <tbody> \
                        <td data-tit="주소검색"> \
                          <el-input v-model="searchKeyword" maxlength="50" style="ime-mode: active" placeholder="주소 또는 우편번호 입력" class="p8" @keyup.enter.native="getPostCode()" /> \
                          <a @click="getPostCode()" class="btn spot">검색</a> \
                        </td> \
                      </tr> \
                    </tbody> \
                  </table> \
                </div> \
                <div class="list-type" style="max-height: 400px; overflow-y: auto"> \
                  <table> \
                    <colgroup> \
                      <col style="width: 150px" /> \
                      <col style="width: *"/> \
                      <col style="width: 100px" /> \
                    </colgroup> \
                    <thead> \
                      <tr> \
                        <th scope="col">우편번호</th> \
                        <th scope="col">주소</th> \
                        <th scope="col">선택</th> \
                      </tr> \
                    </thead> \
                    <tbody> \
                      <tr v-if="resultList.length == 0"> \
                        <td colspan="3"> \
                          <div class="bg-box fs-sm"> \
                            <cite class="box-tit">[안내]</cite> \
                            <p>검색 조건을 아래와 유사하게 입력해 주세요.<br>\
                            <b>도로명 + 건물번호</b><br>\
                            예) 판교역로192번길, 대왕판교로 700,  삼성동 172 <br>\
                            <b>지역명(동/리) + 번지</b> <br> \
                            예) 중동 1289<br>\
                            <b>우편번호 단독 검색</b> <br> \
                            예) 13524</p>\
                          </div>\
                        </td> \
                      </tr> \
                      <tr v-for="(item, index) in resultList" :key="index"> \
                        <td class="ac" data-tit="우편번호">{{ item.zipNo }}</td> \
                        <td class="al" data-tit="주소">{{ getFulladdr(item) }}</td> \
                        <td data-tit="선택"> \
                          <a class="btn-sm spot2" @click="setZipCd(item)"><span>선택</span></a> \
                        </td> \
                      </tr> \
                    </tbody> \
                  </table> \
                </div> \
              </div> \
            </el-dialog> \
        </span> \
    ',
  props: ["value", "buttonCss", "address1", "selection", "visible"],
  data: function () {
    return {
      resultList: [],
      isSearchPostsView: false,
      searchKeyword: "",
      fieldMap: "",
      fieldName: "",
      currentPage: 1,
      countPerPage: 10,
      confmKey: "U01TX0FVVEgyMDI1MDkxODExNDcyMjExNjIxMjQ=",
    };
  },
  methods: {
    show() {
      this.isSearchPostsView = true;
    },
    getPostCode() {
      this.resultList = [];
      this.loader();
      this.request(apiURL + "/code/zipcd/list", "searchKeyword=" + this.searchKeyword).then(({ data }) => {
        this.loader("close");
        if (data instanceof Array) {
          this.resultList = data;
        }
      });
    },
    getFulladdr(item) {
      var fullRoadAddr = item.roadAddrPart1; // 도로명 주소 변수
      var extraRoadAddr = ""; // 도로명 조합형 주소 변수

      // 법정동명이 있을 경우 추가한다. (법정리는 제외)
      // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
      if (item.emdNm !== "" && /[동|로|가]$/g.test(item.emdNm)) {
        extraRoadAddr += item.emdNm;
      }
      // 건물명이 있고, 공동주택일 경우 추가한다.
      if (item.bdNm !== "") {
        extraRoadAddr += extraRoadAddr !== "" ? ", " + item.bdNm : item.bdNm;
      }
      // 도로명, 지번 조합형 주소가 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
      if (extraRoadAddr !== "") {
        extraRoadAddr = " (" + extraRoadAddr + ")";
      }
      // 도로명, 지번 주소의 유무에 따라 해당 조합형 주소를 추가한다.
      if (fullRoadAddr !== "") {
        fullRoadAddr += extraRoadAddr;
      }
      return fullRoadAddr;
    },
    setZipCd(item) {
      this.isSearchPostsView = false;
      this.$emit("selection", { zipcode: item.zipNo, address1: this.getFulladdr(item) });
    },
  },
  watch: {
    visible: function (to, from) {
      this.isSearchPostsView = to;
    },
  },
  mounted: function () {},
});

Vue.component("search-zipcode", {
  template:
    '\
        <span> \
            <el-dialog title="우편번호 검색" :visible.sync="isSearchPostsView" :width="isMobile() ? \'100%\' : \'60%\'"> \
            <div id="layerPostCode"> \
            </div> \
            </el-dialog> \
        </span> \
    ',
  props: ["value", "buttonCss", "address1", "selection", "visible"],
  data: function () {
    return {
      isSearchPostsView: false,
      searchKeyword: "",
      fieldMap: "",
      fieldName: "",
    };
  },
  methods: {
    show() {
      this.isSearchPostsView = true;
      this.$nextTick(() => {
        this.getPostCode();
      });
    },
    getPostCode: function () {
      var self = this;
      try {
        new kakao.Postcode({
          oncomplete: function (data) {
            var fullRoadAddr = data.roadAddress; // 도로명 주소 변수
            if (fullRoadAddr == null || fullRoadAddr == "") {
              fullRoadAddr = data.autoRoadAddress;
            }
            var extraRoadAddr = ""; // 도로명 조합형 주소 변수

            // 법정동명이 있을 경우 추가한다. (법정리는 제외)
            // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
            if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
              extraRoadAddr += data.bname;
            }
            // 건물명이 있고, 공동주택일 경우 추가한다.
            if (data.buildingName !== "" && data.apartment === "Y") {
              extraRoadAddr += extraRoadAddr !== "" ? ", " + data.buildingName : data.buildingName;
            }
            // 도로명, 지번 조합형 주소가 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
            if (extraRoadAddr !== "") {
              extraRoadAddr = " (" + extraRoadAddr + ")";
            }
            // 도로명, 지번 주소의 유무에 따라 해당 조합형 주소를 추가한다.
            if (fullRoadAddr !== "") {
              fullRoadAddr += extraRoadAddr;
            }

            self.isSearchPostsView = false;

            // 우편번호와 주소 정보를 해당 필드에 넣는다.
            self.$emit("selection", { zipcode: data.zonecode, address1: fullRoadAddr });
          },
          width: "100%",
          height: "500px",
        }).embed(document.getElementById("layerPostCode"), { q: self.searchKeyword });
      } catch (ex) {
        alert(ex);
      }
    },
  },
  watch: {
    visible: function (to, from) {
      this.isSearchPostsView = to;
      if (to) {
        this.$nextTick(() => {
          this.getPostCode();
        });
      }
    },
  },
  mounted: function () {
    if (typeof kakao == "undefined") {
      $.ajaxPrefilter(function (options) {
        if (options.dataType === "script") {
          options.cache = true;
        }
      });

      $.getScript("//t1.kakaocdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js", function () {
        kakao.postcode.load(function () {
          //self.getPostCode();
        });
      });
    }
  },
});

Vue.component("file-upload", {
  template:
    '\
      <div> \
          <el-upload class="upload-demo" style="max-width: 500px;" ref="input" :action="action" name="file" :auto-upload="false" :data="data" \
              :on-exceed="handleFileExceed" :on-change="handleFileChange" :on-success="handleFileSuccess" :on-progress="handleFileProgress" :on-preview="handleFilePreview" :on-remove="handleFileRemove"\
              :file-list="fileList"  multiple  withCredentials  :before-remove="beforeRemove" \
              :limit="limit" :accept="accept" :list-type="listType" v-bind:value="value"> \
              <div class="el-upload__tip" slot="tip">{{ fileCountTxt }} &nbsp; {{ fileSizeTxt }}</div> \
              <el-button size="small" type="primary">파일선택</el-button> \
          </el-upload> \
          <el-dialog :visible.sync="visiblePreview" append-to-body>	\
            <img width="100%" :src="dialogImageUrl" alt=""> \
          </el-dialog> \
      </div> \
  ',
  props: {
    types: { type: String, default: "" },
    value: null,
    fileSubPath: { type: String, default: "" },
    select: {},
    repositoryId: null,
    param: { type: String, default: "" },
  },
  data: function () {
    return {
      id: "",
      valueOrg: null,
      action: "",
      accept: "",
      limit: 1,
      fileType: { type: String, default: "" },
      limitCnt: { type: String, default: "0" },
      limitSize: { type: String, default: "0" },
      multiple: true,
      listType: "text",
      fileList: [],
      fileSizeTxt: "",
      fileCountTxt: "",
      fileUploaded: [],
      visiblePreview: false,
      dialogImageUrl: null,
      data: {},
    };
  },
  methods: {
    init: function () {
      this.request(apiURL + "/file/rpstry", "repositoryId=" + this.repositoryId + "&fileSubPath=" + this.fileSubPath).then(({ data }) => {
        // this.fileType = data.fileTypeDesc;
        this.fileType = data.fileType;
        this.limitCnt = data.fileLimitCnt;
        this.limitSize = data.fileLimitSize;

        if (this.fileType != "") {
          this.accept = "." + this.fileType.replace(/,/gi, ",.");
        }

        this.multiple = Number(this.limitCnt) == 1 ? true : false;
        this.limit = Number(this.limitCnt) - this.fileList.length;

        this.handleFileStatus();
      });
    },
    getList: function () {
      this.fileList = [];
      if (this.value == undefined || this.value == null || this.value == "") {
        return false;
      }

      this.request(apiURL + "/file/list", "repositoryId=" + this.repositoryId + "&attachId=" + this.value).then(({ data }) => {
        if (data instanceof Array) {
          this.fileList = data;
          this.handleFileStatus();
        }
      });
    },
    uploadStart: function (request) {
      var self = this;
      this.$root.loadings();

      var tempIndex = 1;
      this.request(apiURL + "/file/presigned", "repositoryId=" + this.repositoryId + "&fileNm=" + request.file.name).then(({ data }) => {
        let uid = Date.now() + tempIndex++;
        let file = {
          status: "ready",
          name: request.file.name,
          realFileNm: request.file.name,
          strgFileNm: uid,
          size: request.file.size,
          percentage: 0,
          uid: uid,
          fileSize: request.file.size,
          encodedPath: e.encodedPath,
        };

        const controller = new AbortController();
        axios({
          url: e.signedUrl,
          method: "put",
          data: request.file,
          headers: { "Content-Type": request.file.type },
          signal: controller.signal,
          onUploadProgress: (progressEvent) => {
            file.status = "uploading";
            file.percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total) || 0;

            let ev = { percent: file.percentage };
            self.$root.loading.text = "진행률 : " + file.percentage + "% / 잔여수 : " + self.$root.fileUploadCnt;
            try {
              request.onProgress(ev, file, this.fileList);
            } catch (e) {
              controller.abort();
              self.$root.loading.close();
            }
          },
        })
          .then((response) => {
            request.onSuccess(file, response, this.fileList);
            //handleSuccess(res, rawFile)
          })
          .catch((response) => {
            request.onError(file, response, this.fileList);
            if (this.loading != null) this.loading.close();
            if (this.loading2 != null) this.loading2.close();
          });
      });
    },
    handleFileRemove: function (file, fileList) {
      if (file.status == null || file.status != "ready") {
        this.request(apiURL + "/file/FileDelete.do", "repositoryId=" + this.repositoryId + "&attachId=" + this.value + "&fileSeqno=" + (file.fileSeqno || 0)).then((e) => {
          //this.fileList.splice(this.fileList.indexOf(file), 1);
          this.handleFileChange(file, fileList);
        });
      } else {
        this.handleFileChange(file, fileList);
      }
    },
    handleFilePreview: function (file) {
      var url = apiURL + "/file/view?repositoryId=" + this.repositoryId + "&attachId=" + file.attachId + "&fileSeqno=" + file.fileSeqno;
      var fileExt = file.name.split(".").pop();
      if (fileExt.match(/(jpg|jpeg|png|gif)$/i)) {
        this.dialogImageUrl = "about:blank";
        this.dialogImageUrl = file.fileSeqno != null ? url : URL.createObjectURL(file.raw);
        this.visiblePreview = true;
        return;
      } else {
        $("body #downloadFrame").remove();
        $("body").append('<iframe id="downloadFrame" style="display:none;"></iframe>');
        $("#downloadFrame").prop("src", apiURL + "/file/download?repositoryId=" + this.repositoryId + "&attachId=" + file.attachId + "&fileSeqno=" + file.fileSeqno);
      }
    },
    handleFileSuccess: function (response, file) {
      if (file.status == "success") {
        this.fileUploaded.push(response);

        var uploadCnt = 0;
        this.fileList.forEach(function (r, i) {
          if (r.status != "uploaded") {
            uploadCnt++;
          }
        });

        if (this.fileUploaded.length >= uploadCnt) {
          delete this.fileUploaded.status;

          var json = '{ "repositoryId" : "' + this.repositoryId + '" ,';
          json += ' "attachId" : "' + (this.value != undefined ? this.valueOrg : "") + '" ,';
          json += ' "fileSubPath" : "' + (this.fileSubPath != undefined ? this.fileSubPath : "") + '" ,';
          json += '"inputData": ' + JSON.stringify(this.fileUploaded) + " }";

          this.fileUploaded = [];
          this.$emit("input", json);

          this.$root.$emit("fileUploadComplete", file);
        }
      }
    },
    beforeRemove(file) {
      return this.$confirm(file.name + " 파일을 삭제 하시겠습니까?").then(() => {
        this.$refs.input.abort();
        this.handleFileRemove(file);
      });
    },
    handleFileProgress: function (event, file) {
      //console.log(event);
      //console.log(file);
    },
    handleFileExceed: function (file) {
      this.$message.error("최대 " + this.limitCnt + "개까지 업로드 가능합니다.");
    },
    handleFileChange: function (file, fileList) {
      if (fileList != null) {
        this.fileList = fileList;
      }
      var totalSize = 0;
      if (this.fileList != null && this.fileList.length > 0) {
        this.fileList.forEach(function (r, i) {
          totalSize += r.size;
        });
      }

      if (totalSize / 1024 / 1024 > Number(this.limitSize)) {
        this.$message.error("최대 " + this.limitSize + "Mb 까지 업로드 가능합니다.");
        this.fileList = this.fileList.slice(0, this.fileList.length - 1);
        return;
      }

      this.$emit("update:change", file, this.fileList);
      this.handleFileStatus();
    },
    handleFileStatus: function () {
      var totalCnt = 0;
      var totalSize = 0;
      if (this.fileList != null && this.fileList.length > 0) {
        this.fileList.forEach(function (r, i) {
          totalSize += r.size;
          totalCnt += 1;
        });
      }

      totalSize = Vue.filter("fileSizeFormat")(totalSize);
      this.fileSizeTxt = "파일 " + totalSize + "/" + this.limitSize + "MB 이내 ";
      this.fileCountTxt = "최대 " + totalCnt + "/" + this.limitCnt + " 개 첨부가능, ";
      // this.fileCountTxt = "갯수 : " + totalCnt + "/" + this.limitCnt;
      // this.fileSizeTxt = "용량 : " + totalSize + "/" + this.limitSize + "Mb";
    },
    actionUrl: function () {
      this.action = apiURL + "/file/upload?" + this.param;
      this.action += "&repositoryId=" + this.repositoryId;
      if (this.attachId != null) this.action += "&attachId=" + this.attachId;
      if (this.fileSubPath != null) this.action += "&fileSubPath=" + this.fileSubPath;
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: function (newValue) {
        //this.actionUrl();
        if (newValue != null && newValue.indexOf("{") > -1) {
          return false;
        } else {
          this.valueOrg = this.value;
          if (newValue != null) {
            this.getList();
          } else {
            this.fileList = [];
          }
        }
      },
    },
    fileSubPath: {
      deep: true,
      immediate: true,
      handler: function () {
        //this.actionUrl();
      },
    },
  },
  mounted: function () {
    if (this.types == "image") {
      this.listType = "picture-card";
    } else this.listType = "text";

    this.init();
    this.getList();
    this.actionUrl();
    this.handleFileStatus(null);
  },
});

Vue.component("file-download", {
  name: "file-download",
  template:
    '\
      <div> \
          <ul class="file"> \
              <li v-for="item in fileList"><i class="ico-file"></i><a @click="handleFileDownload(item)">{{ item.name }}</a> <span>({{ item.fileSize | fileSizeFormat }})</span></li> \
          </ul> \
      </div> \
  ',
  props: {
    value: null,
    fileType: { type: String, default: "" },
    repositoryId: null,
    allowVideo: { type: Boolean, default: false },
  },
  data: function () {
    return {
      fileList: [],
    };
  },
  methods: {
    getList: function () {
      if (this.value == undefined || this.value == null) {
        this.fileList = null;
        return;
      }

      this.request(apiURL + "/file/list", "repositoryId=" + this.repositoryId + "&attachId=" + this.value).then(({ data }) => {
        this.fileList = [];
        data.map((item) => {
          var fileExt = item.name.split(".").pop();
          if (this.allowVideo || !fileExt.match(/(mp4)$/i)) {
            this.fileList.push(item);
          }
        });
      });
    },
    handleFileDownload: function (file) {
      var url = apiURL + "/file/download?repositoryId=" + this.repositoryId + "&attachId=" + file.attachId + "&fileSeqno=" + file.fileSeqno;
      fetch(url)
        .then((resp) => resp.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = file.realFileNm;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(() => console.log("file download error"));
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: function (newValue, oldValue) {
        if (newValue != null && newValue.indexOf("{") == -1) {
          this.getList();
        } else {
          this.fileList = [];
        }
      },
    },
  },
  mounted: function () {
    this.getList();
  },
});

Vue.component("file-img-preview", {
  template:
    '\
      <div> \
          <ul class="uploadFileList"> \
              <li v-for="item in fileList"> \
                  <cite class="fileName"><a @click="handleFilePreview(item)">{{ item.name }}</a></cite> \
                  <img :src="item.fileUrl" :class="cssClass" v-if="item.fileNm.includes(\'png\') || item.fileNm.includes(\'jpg\') || item.fileNm.includes(\'gif\')" /> \
              </li> \
          </ul> \
      </div> \
  ',
  props: {
    value: null,
    fileSeqno: { type: Number },
    fileType: { type: String, default: "" },
    repositoryId: null,
    width: { type: String, default: "0" },
    height: { type: String, default: "0" },
    cssClass: { type: String, default: "thumb" },
  },
  data: function () {
    return {
      fileList: [],
    };
  },
  methods: {
    getList: function () {
      if (this.value == undefined || this.value == null || this.value == "null") {
        this.fileList = null;
        return;
      }

      this.fileList = [];
      this.request(apiURL + "/file/list", "repositoryId=" + this.repositoryId + "&attachId=" + this.value + "&fileSeqno=" + (this.fileSeqno || "")).then(({ data }) => {
        data.map((item) => {
          var fileExt = item.name.split(".").pop();
          if (fileExt.match(/(jpg|jpeg|png|gif)$/i)) {
            this.fileList.push(item);
          }
        });
      });
    },
    handleFilePreview: function (file) {
      var fileExt = file.name.split(".").pop();
      var url = apiURL + "/file/view?repositoryId=" + this.repositoryId + "&attachId=" + file.attachId + "&fileSeqno=" + file.fileSeqno;
      if (fileExt.match(/(jpg|jpeg|png|gif)$/i)) {
        if (Vue.prototype.isApp()) {
          window.ReactNativeWebView.postMessage(JSON.stringify({ action: "popup", url: url }));
          return;
        }

        window.open(url);
      } else {
        var url = apiURL + "/file/download?repositoryId=" + this.repositoryId + "&attachId=" + file.attachId + "&fileSeqno=" + file.fileSeqno;
        fetch(url)
          .then((resp) => resp.blob())
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            a.download = file.realFileNm;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          })
          .catch(() => console.log("file download error"));
      }
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: function (newValue, oldValue) {
        if (newValue != null && newValue.indexOf("{") == -1) {
          this.getList();
        } else {
          this.fileList = [];
        }
      },
    },
  },
  mounted: function () {
    this.getList();
  },
});

Vue.component("file-video-view", {
  components: {
    // common.js 는 전역이라 모든 화면이 받는다. 여기서 static import 하면
    // video.js(188KiB)가 초기 번들에 들어간다. 실제로 쓰는 건 게시판 상세뿐이다.
    VideoPlayer: () => import("@/components/VideoPlayer.vue"),
  },
  template:
    '\
      <div> \
          <ul> \
            <li v-for="item in fileList" style="padding-bottom:10px"> \
              <video-player ref="item.player" :options="item.playerOptions" /> \
            </li> \
          </ul> \
      </div> \
  ',
  props: {
    value: null,
    fileSeqno: { type: Number },
    fileType: { type: String, default: "" },
    repositoryId: null,
    width: { type: String, default: "0" },
    height: { type: String, default: "0" },
    cssClass: { type: String, default: "thumb" },
  },
  data: function () {
    return {
      fileList: [],
      playerOptions: null,
    };
  },
  methods: {
    getList: function () {
      if (this.value == undefined || this.value == null || this.value == "null") {
        this.fileList = null;
        return;
      }

      this.fileList = [];
      this.request(apiURL + "/file/list", "repositoryId=" + this.repositoryId + "&attachId=" + this.value + "&fileSeqno=" + (this.fileSeqno || "") + "&re=video").then(
        ({ data }) => {
          data.map((item) => {
            var fileExt = item.name.split(".").pop();
            if (fileExt.match(/(mp4|mov)$/i)) {
              var url = apiURL + "/file/view?repositoryId=" + this.repositoryId + "&attachId=" + item.attachId + "&fileSeqno=" + item.fileSeqno + "&re=video";

              item.player = null;
              item.playerOptions = {
                src: [
                  {
                    src: url,
                    type: "video/mp4",
                    withCredentials: true,
                  },
                ],
                currentTime: 0,
                langCd: this.$i18n.locale,
              };
              this.fileList.push(item);
            }
          });
        },
      );
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: function (newValue, oldValue) {
        if (newValue != null && newValue.indexOf("{") == -1) {
          this.getList();
        } else {
          this.fileList = [];
        }
      },
    },
  },
  mounted: function () {
    // this.getList();
  },
});

Vue.component("file-img-view", {
  template:
    '\
      <div> \
          <span v-for="item in fileList"><img :src="item.fileUrl" :class="cssClass" /></span> \
      </div> \
  ',
  props: {
    value: null,
    fileSeqno: { type: Number },
    fileType: { type: String, default: "" },
    repositoryId: null,
    width: { type: String, default: "0" },
    height: { type: String, default: "0" },
    cssClass: { type: String, default: "thumb" },
  },
  data: function () {
    return {
      fileList: [],
    };
  },
  methods: {
    getList: function () {
      if (this.value == undefined || this.value == null || this.value == "null") {
        this.fileList = null;
        return;
      }

      this.fileList = [];
      this.request(apiURL + "/file/list", "repositoryId=" + this.repositoryId + "&attachId=" + this.value + "&fileSeqno=" + (this.fileSeqno || "")).then(({ data }) => {
        if (data == null) {
          return;
        }

        data.map((item) => {
          var fileExt = item.name.split(".").pop();
          if (fileExt.match(/(jpg|jpeg|png|gif)$/i)) {
            this.fileList.push(item);
          }
        });
      });
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: function (newValue, oldValue) {
        if (newValue != null && newValue.indexOf("{") == -1) {
          this.getList();
        } else {
          this.fileList = [];
        }
      },
    },
  },
  mounted: function () {
    //this.getList();
  },
});

Vue.component("tinymce-editor", {
  components: { Editor },
  template: `
    <Editor
    ref="input"
    tinymce-script-src="${assetsURL}/js/module/tinymce-6.8.5/tinymce.min.js"
    :init="{
      min_height: Number(this.height || 300),
      plugins: 'autoresize advlist autolink image link lists code nonbreaking table emoticons wordcount',
      toolbar: 'bold italic underline strikethrough | alignleft aligncenter alignright | bullist numlist | fontsizeselect | forecolor backcolor emoticons | table | subscript superscript | link | code',
      menubar: false,
      statusbar: false,
      powerpaste_allow_local_images: true,
      paste_data_images: this.pasteImages,
      images_upload_url: '${apiURL}/file/upload?repositoryId=' + repositoryId + '&fileSubPath=editor&directUpload=true&_csrf=',
      images_upload_credentials: true,
      relative_urls: false,
      remove_script_host: false,
      init_instance_callback: this.initEditor,
      table_default_attributes: {
        border: '1',
      },
      readonly: this.readonly,
      setup: (editor) => {
        editor.on('init', (e) => {
          this.$refs.input.editor.setContent(this.content);
          this.$emit('input', this.content);
        });
      },
    }"
    height="300"
    />
  `,
  props: {
    value: { default: "" },
    readonly: { default: false, type: Boolean },
    rows: { default: "10", type: String },
    height: { default: "300", type: String },
    pasteImages: { default: false, type: Boolean },
    repositoryId: { default: "", type: String },
  },
  data() {
    return {
      input: null,
      editorConfig: null,
      content: "",
      isTyping: false,
      siteURL: siteURL,
    };
  },
  mounted() {
    this.content = this.value;
    try {
      this.init();
    } catch (e) {
      this.$nextTick(() => {
        this.init();
      });
    }
  },
  beforeDestroy() {
    this.$refs.input.editor.remove();
  },
  watch: {
    value: function (newValue) {
      if (newValue == null) {
        newValue = "";
      }
      if (!this.isTyping) {
        if (this.$refs.input !== null) {
          this.init();
          this.$refs.input.editor.setContent(newValue);
        } else this.content = newValue;
      }
    },
  },
  methods: {
    init() {
      this.editorConfig = {
        min_height: Number(this.height || 300),
        plugins: "autoresize advlist autolink image link lists code nonbreaking table emoticons wordcount",
        toolbar:
          "bold italic underline strikethrough | alignleft aligncenter alignright | bullist numlist | fontsizeselect | forecolor backcolor emoticons | table | subscript superscript | link | code",
        menubar: false,
        statusbar: false,
        powerpaste_allow_local_images: true,
        paste_data_images: this.pasteImages,
        images_upload_url: apiURL + "/file/FileUpload.do?repositoryId=" + this.repositoryId + "&fileSubPath=editor&directUpload=true&_csrf=",
        images_upload_credentials: true,
        relative_urls: false,
        remove_script_host: false,
        init_instance_callback: this.initEditor,
        table_default_attributes: {
          border: "1",
        },
        readonly: this.readonly,
        setup: (editor) => {
          editor.on("init", (e) => {
            this.$refs.input.editor.setContent(this.content);
            this.$emit("input", this.content);
          });
        },
      };
    },
    initEditor(editor) {
      editor.on("KeyUp", (e) => {
        this.submitNewContent();
      });
      editor.on("change", (e) => {
        if (this.$refs.input.editor.getContent() !== this.value) {
          this.submitNewContent();
        }
        this.$emit("editorChange", e);
      });

      this.$emit("editorInit", editor);

      let value = this.value;
      this.$nextTick(() => {
        this.$refs.input.editor.setContent(value);
        this.$emit("input", this.$refs.input.editor.getContent());
      });
    },
    submitNewContent() {
      this.isTyping = true;
      if (this.checkerTimeout !== null) clearTimeout(this.checkerTimeout);
      this.checkerTimeout = setTimeout(() => {
        this.isTyping = false;
      }, 300);

      this.$emit("input", this.$refs.input.editor.getContent());
    },
  },
});
